import { useMemo } from 'react'
import ReactJsonViewCompare from 'react-json-view-compare'
import { useParams } from 'react-router-dom'

import { Spinner } from '../../../Components'
import { useCQuery } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const sortObjectKeys = (obj) => {
  if (Array.isArray(obj)) return obj.map(sortObjectKeys)
  if (obj && typeof obj === 'object') {
    return Object.keys(obj)
      .sort()
      .reduce((sorted, key) => {
        sorted[key] = sortObjectKeys(obj[key])
        return sorted
      }, {})
  }
  return obj
}

export const JsonView = ({ stateIndex }) => {
  const { processId } = useParams()
  const { data: processSteps = [], isSuccess } = useCQuery(['processSteps', processId])

  const oldData = useMemo(
    () => sortObjectKeys(processSteps[stateIndex]?.initialState || {}),
    [processSteps, stateIndex]
  )
  const newData = useMemo(
    () => sortObjectKeys(processSteps[stateIndex]?.finalState || {}),
    [processSteps, stateIndex]
  )

  if (!isSuccess) return <Spinner />

  return (
    <div className="ncard process-compare-compare-wrap" id="compare" style={{ padding: 0 }}>
      <div className="process-compare-labels">
        <div className="ncard__head" style={{ borderBottom: '1px solid var(--border)', flex: 1 }}>
          <div className="ncard__ico">
            <i className="pi pi-file" style={{ fontSize: 16 }} />
          </div>
          <h3 className="ncard__title">{t.pfInitialState}</h3>
        </div>
        <div className="ncard__head" style={{ borderBottom: '1px solid var(--border)', flex: 1 }}>
          <div className="ncard__ico">
            <i className="pi pi-file-edit" style={{ fontSize: 16 }} />
          </div>
          <h3 className="ncard__title">{t.pfFinalState}</h3>
        </div>
      </div>
      <div className="ncard__body process-compare-card__body">
        <ReactJsonViewCompare oldData={oldData} newData={newData} />
      </div>
    </div>
  )
}
